// extracted by mini-css-extract-plugin
module.exports = {"Paragraph":"Paragraph_Paragraph__AYTX0","p1":"Paragraph_p1___7rgu","p2":"Paragraph_p2__kGQ0o","p3":"Paragraph_p3__iV6F5","critical":"Paragraph_critical__B9okM"};